<div class="map" id="map{{ eventId }}"></div>